//hooks
import UseCommentPost from "./CommentPost.hooks";

//interfaces
import { UserActivity } from "@/interfaces/activityFeed";
import { ICommentPost } from "@/interfaces/activityFeedNotifications";

//components
import { ActionFeedbackBanner } from "thrive-components";
import CommentInputPanel from "../../elements/commentInputPanel/CommentInputPanel";
import UserComment from "../../elements/userComment/UserComment";
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import DeleteComment from "../../elements/deleteComment/DeleteComment";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import CommentPostTitle from "../../elements/notificationTitle/CommentPostTitle/CommentPostTitle";

//styling
import "../../../../../css/activityFeed/notifications/comment-activity.scss";



const CommentPost = ({zIndexNum, activityId, isPopOut = false, timeStamp, dateStamp, user, meta, parentList, content, comment, appDetails, editorProfileImage, onLikeClick, onPostCommentClick, getOpenOnWebLink, onDeleteCommentClick, notificationDetails}: ICommentPost) => {
    const {screenClassName, deletedCommentClassName, showDeletedBanner, truncation, handleLikeClick, isLiked, handleReplyClick, handleDeleteClick, hideMenu, commentString, deletedBannerMessage, setCommentString, onCommentClick, showCommentFunctionality, setShowCommentFunctionality, showFeedbackBanner, feedbackType, feedbackMessage, showDeleteFunctionality, onHideDeleteFunctionality, onDelete, activityInformation, isPosting } = UseCommentPost({activityId, isPopOut, timeStamp, dateStamp, meta, parentList, comment, content, appDetails, onLikeClick, onPostCommentClick, onDeleteCommentClick, notificationDetails});

    return (
        <div className={`${isPopOut ? "" : "comment-notification-full"} comment-notification notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={user.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={UserActivity.comment} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <CommentPostTitle 
                    content={content} 
                    user={user.name} 
                    isPopOut={isPopOut}
                />
            </div>        
            
            <UserComment 
                zIndexNum={zIndexNum} 
                className={`${screenClassName} ${deletedCommentClassName}`} 
                commentText={comment.text} 
                truncateNumber={truncation} 
                onLikeClick={handleLikeClick} 
                isLiked={isLiked} 
                onReplyClick={handleReplyClick} 
                getWebLink={getOpenOnWebLink} 
                onDeleteClick={handleDeleteClick} 
                isReply={true} 
                hideMenu={hideMenu}
            />

            <CommentInputPanel 
                className={screenClassName} 
                commentString={commentString} 
                setCommentString={setCommentString} 
                onPostCommentClick={onCommentClick} 
                showCommentFunctionality={showCommentFunctionality} 
                setShowCommentFunctionality={setShowCommentFunctionality} 
                isPosting={isPosting}
                profileImageUrl={editorProfileImage ?? ""}
            />   
            
            {showFeedbackBanner && 
                <ActionFeedbackBanner 
                    feedbackType={feedbackType} 
                    feedbackMessage={feedbackMessage} 
                />
            }            
            
            <DeletedBanner 
                isDeleted={showDeletedBanner} 
                message={deletedBannerMessage}
            />

            <DeleteComment 
                showModal={showDeleteFunctionality} 
                onCloseClick={onHideDeleteFunctionality} 
                onConfirmClick={onDelete} 
                isInlineStyle={isPopOut} 
            />

            <ActivityInformationPanel
                {...activityInformation}
            />
        </div>
    )
};

export default CommentPost